import React, { useEffect, useState } from 'react';
import "./Services.css";
import AllIntroTemplate from '../../components/AllIntroTemplate/AllIntroTemplate';
import Loader from "../../components/Loader/Loader";
import { getStoredData } from "../../json/fetchData";
import ServicesDetails from '../../components/ServicesDetails/ServicesDetails';

const Services = () => {
  const [introData, setIntroData] = useState(null);
  const [serviceData, setServiceData] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const stored = getStoredData();
        setIntroData(stored?.["4"]); // Use your actual key for intro

        const response = await fetch("https://aspwppl-backend.vercel.app/activities");
        const result = await response.json();
        setServiceData(result);
      } catch (error) {
        console.error("Error loading services data:", error);
      }
    };

    loadData();
  }, []);

  if (!introData || !serviceData) {
    return <Loader />;
  }

  return (
    <div className='services'>
      <AllIntroTemplate 
        title={introData.Introsubtitle} 
        image={introData.Introimage} 
      />
      <ServicesDetails dataList={serviceData}/>
    </div>
  );
};

export default Services;